// import request from './request';
import { request } from 'root/common/request';
import Config from 'root/common/config/config';
import locationUtil from '@/blackcard/util/location/locationUtil';

// const appid = 'wx9b3ada98e020c31b';

/**
 * 获取超市列表
 *
 *
 * @returns
 */
export function getSuperMarketList() {
    return request({
        url: Config.api.superMarket.getSuperMarketList,
        params: {
            pageTag: 'supermarket',
            cityId: (locationUtil.getChooseCityCache() || {}).id,
        },
        // isNeedToken: false,
        // isShowCatchErr: false,
    });
}

/**
 * 获取超市列表
 *
 *
 * @returns
 */
export function getSuperMarketBanner() {
    return request({
        url: Config.api.superMarket.getSuperMarketList,
        params: {
            pageTag: 'supermarket_list',
            cityId: (locationUtil.getChooseCityCache() || {}).id,
        },
        // isNeedToken: false,
        // isShowCatchErr: false,
    });
}

/**
 * 获取超市订单列表
 *
 * @returns
 */

export function getSuperMarketQueryOrderUrl(params = {}, options = {}) {
    return request({
        url: `${Config.privilegeDomain}/supermarket/order/v1/queryOrderUrl`,
        method: 'GET',
        params,
        ...options,
    });
}

/**
 * 获取供应商联登链接接口
 *
 * @returns
 */

export function getSuperMarketUnionLoginUrl(params = {}, options = {}) {
    return request({
        url: `${Config.privilegeDomain}/supermarket/v1/buyPack`,
        method: 'GET',
        params,
        ...options,
    });
}

/**
 * 获取供应商商超列表联登链接接口
 *
 * @returns
 */

export function getSuperMarketListUnionLoginUrl(params = {}, options = {}) {
    return request({
        url: `${Config.privilegeDomain}/supermarket/v1/getUrl`,
        method: 'GET',
        params,
        ...options,
    });
}
